/* Goal Station front-end behaviour. No dependencies. */
(function(){
  document.documentElement.classList.add('js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function(s, r){ return (r||document).querySelector(s); };
  var $$ = function(s, r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };

  /* ---------- nav ---------- */
  function initNav(){
    var nav = $('.nav'); if(!nav) return;
    var drawer = $('.drawer');
    var bar = $('.mobile-bar');
    var onScroll = function(){
      nav.classList.toggle('is-scrolled', window.scrollY > 24);
      if(bar) bar.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.7);
    };
    var ticking = false;
    window.addEventListener('scroll', function(){ if(!ticking){ requestAnimationFrame(function(){ onScroll(); ticking=false; }); ticking=true; } }, {passive:true});
    onScroll();
    // mega menus
    $$('.nav__item[data-menu]').forEach(function(item){
      var btn = $('button', item);
      var open = function(){ closeAll(); item.classList.add('is-open'); btn.setAttribute('aria-expanded','true'); };
      var close = function(){ item.classList.remove('is-open'); btn.setAttribute('aria-expanded','false'); };
      item._close = close;
      var canHover = window.matchMedia('(hover:hover)').matches;
      btn.addEventListener('click', function(e){ e.stopPropagation(); if(item.classList.contains('is-open') && !canHover){ close(); } else { open(); } });
      if(window.matchMedia('(hover:hover)').matches){
        var t; item.addEventListener('mouseenter', function(){ clearTimeout(t); open(); });
        item.addEventListener('mouseleave', function(){ t = setTimeout(close, 120); });
      }
    });
    function closeAll(){ $$('.nav__item[data-menu]').forEach(function(i){ i._close && i._close(); }); }
    document.addEventListener('click', closeAll);
    document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ closeAll(); setDrawer(false); } });
    var burger = $('.nav__burger');
    function setDrawer(v){ nav.classList.toggle('is-open', v); if(drawer) drawer.classList.toggle('is-open', v); document.body.style.overflow = v ? 'hidden' : ''; burger && burger.setAttribute('aria-expanded', v?'true':'false'); }
    if(burger) burger.addEventListener('click', function(){ setDrawer(!nav.classList.contains('is-open')); });
    if(drawer) $$('a', drawer).forEach(function(a){ a.addEventListener('click', function(){ setDrawer(false); }); });
  }

  /* ---------- reveals ---------- */
  function initReveal(){
    var els = $$('.rv, .rv-clip');
    if(!('IntersectionObserver' in window) || reduce){ els.forEach(function(e){ e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, {rootMargin:'0px 0px -10% 0px', threshold:0.08});
    els.forEach(function(e){ io.observe(e); });
    $$('[data-stagger]').forEach(function(g){ $$(':scope > *', g).forEach(function(c,i){ c.style.setProperty('--i', i); }); });
  }

  /* ---------- counters ---------- */
  function initCounters(){
    var els = $$('[data-count]');
    if(!els.length) return;
    var run = function(el){
      var target = parseFloat(el.getAttribute('data-count'));
      var dec = (el.getAttribute('data-count').split('.')[1]||'').length;
      var start = performance.now(), dur = reduce ? 0 : 900;
      var fmt = function(v){ return v.toLocaleString('en-GB', {minimumFractionDigits:dec, maximumFractionDigits:dec}); };
      var tick = function(now){
        var p = dur ? Math.min(1,(now-start)/dur) : 1; p = 1 - Math.pow(1-p, 3);
        el.textContent = fmt(target*p);
        if(p<1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    if(!('IntersectionObserver' in window) || reduce){ return; }
    els.forEach(function(e){ e.textContent = '0'; });
    var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ run(en.target); io.unobserve(en.target); } }); }, {threshold:0.2});
    els.forEach(function(e){ io.observe(e); });
  }

  /* ---------- chapters nav ---------- */
  function initChapters(){
    $$('.chapters').forEach(function(sec){
      var links = $$('.chapters__nav a', sec), steps = $$('.chapter', sec);
      if(!links.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(en.isIntersecting){ var i = steps.indexOf(en.target); links.forEach(function(l,j){ l.classList.toggle('is-active', i===j); }); } });
      }, {rootMargin:'-40% 0px -50% 0px'});
      steps.forEach(function(s){ io.observe(s); });
      links.forEach(function(l,i){ l.addEventListener('click', function(e){ e.preventDefault(); steps[i].scrollIntoView({behavior: reduce?'auto':'smooth', block:'center'}); }); });
    });
  }

  /* ---------- gallery ---------- */
  function initGallery(){
    $$('[data-gallery]').forEach(function(wrap){
      var track = $('.gallery', wrap);
      $$('[data-dir]', wrap).forEach(function(b){ b.addEventListener('click', function(){ var w = track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 14 : 400; track.scrollBy({left: (b.getAttribute('data-dir')==='next'?1:-1)*w, behavior: reduce?'auto':'smooth'}); }); });
    });
  }

  /* ---------- video ---------- */
  function initVideo(){
    var vids = $$('video[autoplay]');
    if(!vids.length) return;
    if(reduce){ vids.forEach(function(v){ v.removeAttribute('autoplay'); v.pause(); }); return; }
    if(!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ var v = en.target; if(en.isIntersecting){ v.play && v.play().catch(function(){}); } else { v.pause(); } }); }, {threshold:0.15});
    vids.forEach(function(v){ io.observe(v); });
  }

  /* ---------- form ---------- */
  function initForm(){
    $$('form.form:not([data-enquiry])').forEach(function(f){
      f.addEventListener('submit', function(e){
        e.preventDefault();
        var ok = true;
        $$('.field', f).forEach(function(fd){
          var inp = $('input,select,textarea', fd); if(!inp) return;
          var bad = inp.required && (!inp.value.trim() || (inp.type==='email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(inp.value)));
          fd.classList.toggle('is-invalid', bad); if(bad) ok = false;
        });
        if(!ok){ var first = $('.is-invalid input, .is-invalid select', f); first && first.focus(); return; }
        var btn = $('button[type=submit]', f); btn.disabled = true; btn.textContent = 'Sending';
        // Production: POST to HubSpot Forms API (portal 25718159, form 4bf1f65c-223c-4d15-b8af-d129d4ab6104). Preview: simulate.
        var payload = { fields: $$('input,select,textarea', f).map(function(i){ return {name:i.name, value:i.value}; }) };
        var endpoint = f.getAttribute('data-endpoint');
        var done = function(){ f.classList.add('is-sent'); btn.textContent = 'Sent'; };
        if(endpoint){ fetch(endpoint, {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(payload)}).then(done).catch(done); } else { setTimeout(done, 700); }
      });
      $$('input,select,textarea', f).forEach(function(i){ i.addEventListener('input', function(){ i.closest('.field').classList.remove('is-invalid'); }); });
    });
  }


  /* ---------- watch: play a clip or open an image in an on-page viewer (no form, no navigation) ---------- */
  function mediaMarkup(src){
    var yt = src.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
    if(yt) return '<iframe src="https://www.youtube-nocookie.com/embed/'+yt[1]+'?autoplay=1&rel=0" title="Video" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
    var vm = src.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if(vm) return '<iframe src="https://player.vimeo.com/video/'+vm[1]+'?autoplay=1" title="Video" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    if(/\.(png|jpe?g|webp|gif|avif|svg)(\?|#|$)/i.test(src)) return '<img src="'+src.replace(/"/g,'&quot;')+'" alt="">';
    return '<video src="'+src.replace(/"/g,'&quot;')+'" controls autoplay playsinline></video>';
  }
  function openWatch(src, opener){
    var m = document.createElement('div');
    m.className = 'watch'; m.setAttribute('role','dialog'); m.setAttribute('aria-modal','true'); m.setAttribute('aria-label','Video');
    m.innerHTML = '<div class="watch__box"><button class="watch__close" type="button" aria-label="Close"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3 3l10 10M13 3 3 13"/></svg></button>'+mediaMarkup(src)+'</div>';
    document.body.appendChild(m);
    var prev = document.body.style.overflow; document.body.style.overflow = 'hidden';
    var close = function(){
      document.removeEventListener('keydown', onKey);
      m.classList.remove('is-open');
      setTimeout(function(){ if(m.parentNode) m.parentNode.removeChild(m); }, reduce ? 0 : 220);
      document.body.style.overflow = prev;
      if(opener && opener.focus) opener.focus();
    };
    var onKey = function(e){ if(e.key==='Escape') close(); };
    document.addEventListener('keydown', onKey);
    m.addEventListener('click', function(e){ if(e.target===m) close(); });
    $('.watch__close', m).addEventListener('click', close);
    requestAnimationFrame(function(){ m.classList.add('is-open'); $('.watch__close', m).focus(); });
  }
  function initWatch(){
    if(document.documentElement.getAttribute('data-watch-ready')) return;
    document.documentElement.setAttribute('data-watch-ready','1');
    document.addEventListener('click', function(e){
      var a = e.target.closest ? e.target.closest('[data-watch]') : null;
      if(!a) return;
      var src = a.getAttribute('data-watch'); if(!src) return;
      e.preventDefault(); openWatch(src, a);
    });
  }

  /* ---------- expandable panels (evidence story) ---------- */
  function initToggles(){
    $$('[data-toggle]').forEach(function(b){
      var panel = document.getElementById(b.getAttribute('data-toggle')); if(!panel) return;
      b.addEventListener('click', function(){
        var open = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', open ? 'false' : 'true');
        if(open){ panel.setAttribute('hidden',''); } else { panel.removeAttribute('hidden'); }
      });
    });
  }

  /* ---------- enquiry form (booking page): buyer intent, source and HubSpot submission ---------- */
  function initEnquiry(){
    $$('form[data-enquiry]').forEach(function(f){
      var q = new URLSearchParams(location.search);
      var intent = document.documentElement.getAttribute('data-intent') || '';
      // preselect project type from the originating CTA (?type=existing|new|academy|other)
      var typeMap = { existing:'Existing Facility', new:'New Facility', academy:'Club / Academy', other:'A Combination / Other' };
      var sel = $('select[name=project_type]', f);
      var want = typeMap[q.get('type')] || (intent==='academy' ? typeMap.academy : '');
      if(sel && want){ Array.prototype.forEach.call(sel.options, function(o){ if(o.text.trim()===want) sel.value = o.value || o.text; }); }
      // hidden context fields recorded in HubSpot
      var ctx = { buyer_intent: intent || (q.get('type')||''), landing_page: (window.gsSource&&window.gsSource.landing_page)||location.href, referrer: (window.gsSource&&window.gsSource.referrer)||document.referrer||'' };
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','solution'].forEach(function(k){ if(q.get(k)) ctx[k] = q.get(k); });
      Object.keys(ctx).forEach(function(k){ var h = document.createElement('input'); h.type='hidden'; h.name=k; h.value=ctx[k]; f.appendChild(h); });

      f.addEventListener('submit', function(e){
        e.preventDefault();
        f.classList.remove('is-failed');
        var ok = true;
        $$('.field', f).forEach(function(fd){
          var inp = $('input,select,textarea', fd); if(!inp) return;
          var bad = inp.required && (!inp.value.trim() || (inp.type==='email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(inp.value)));
          fd.classList.toggle('is-invalid', bad); if(bad) ok = false;
        });
        if(!ok){ var first = $('.is-invalid input, .is-invalid select, .is-invalid textarea', f); first && first.focus(); return; }
        var btn = $('button[type=submit]', f); var label = btn.innerHTML; btn.disabled = true; btn.textContent = 'Sending';
        var fields = [];
        $$('input,select,textarea', f).forEach(function(i){
          if(!i.name) return;
          if(i.name==='fullname'){ var p = i.value.trim().split(/\s+/); fields.push({name:'firstname', value:p.shift()||''}); fields.push({name:'lastname', value:p.join(' ')}); return; }
          fields.push({name:i.name, value:i.value});
        });
        var m = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/);
        var payload = { fields: fields, context: { pageUri: location.href, pageName: document.title } };
        if(m) payload.context.hutk = m[1];
        var done = function(){ f.classList.add('is-sent'); var ok = $('.form__ok', f); if(ok){ ok.setAttribute('tabindex','-1'); ok.focus(); } };
        var fail = function(){ btn.disabled = false; btn.innerHTML = label; f.classList.add('is-failed'); };
        var endpoint = f.getAttribute('data-endpoint');
        if(!endpoint){ fail(); return; }
        fetch(endpoint, {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(payload)})
          .then(function(r){ if(r.ok){ done(); } else { fail(); } })
          .catch(fail);
      });
      $$('input,select,textarea', f).forEach(function(i){ i.addEventListener('input', function(){ var fd = i.closest('.field'); fd && fd.classList.remove('is-invalid'); }); });
    });
  }

  /* ---------- document pages: table of contents from h2 ---------- */
  function initDoc(){
    $$('.doc').forEach(function(doc){
      var prose = $('.prose', doc), toc = $('.doc__toc', doc); if(!prose || !toc) return;
      var hs = $$('h2', prose); if(hs.length < 2){ toc.hidden = true; doc.classList.add('doc--no-toc'); return; }
      var ol = $('ol', toc); ol.innerHTML = '';
      hs.forEach(function(h,i){ if(!h.id) h.id = 'section-' + (i+1) + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,40); var li = document.createElement('li'); var a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent.trim(); li.appendChild(a); ol.appendChild(li); });
      var links = $$('a', ol);
      if('IntersectionObserver' in window){ var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ var i = hs.indexOf(en.target); links.forEach(function(l,j){ l.classList.toggle('is-active', i===j); }); } }); }, {rootMargin:'-20% 0px -70% 0px'}); hs.forEach(function(h){ io.observe(h); }); }
      if(window.matchMedia('(max-width:900px)').matches) toc.removeAttribute('open');
    });
  }

  /* ---------- word split for hero ---------- */
  function splitWords(){
    $$('[data-words]').forEach(function(h){
      if(h.getAttribute('data-split')) return;
      h.setAttribute('data-split','1');
      var html = h.innerHTML;
      // keep inline tags (em, span.accent) intact by splitting on spaces outside tags
      var parts = html.split(/(\s+)/);
      var out = '', i = 0;
      parts.forEach(function(p){ if(!p.trim()){ out += p; return; } out += '<span class="w"><span style="transition-delay:'+(i*55)+'ms">'+p+'</span></span>'; i++; });
      h.innerHTML = out;
    });
  }


  /* GS tracking: GA4/GTM dataLayer events + source retention */
  function initTrack(){
    var dl=window.dataLayer=window.dataLayer||[];
    function push(name,extra){var o={event:name,page_path:location.pathname,intent:document.documentElement.getAttribute('data-intent')||undefined};for(var k in extra||{})o[k]=extra[k];dl.push(o)}
    var S={};try{S=JSON.parse(sessionStorage.getItem('gs_src')||'{}')}catch(e){}
    if(!S.landing_page){
      S={landing_page:location.pathname,referrer:document.referrer||''};
      new URLSearchParams(location.search).forEach(function(v,k){if(/^utm_/.test(k))S[k]=v});
      try{sessionStorage.setItem('gs_src',JSON.stringify(S))}catch(e){}
    }
    window.gsSource=S;
    var isBooking=/\/pages\/design\/?$/.test(location.pathname);
    push('gs_landing_page_view',{landing_page:S.landing_page});
    if(isBooking){
      var v=document.documentElement.getAttribute('data-view');
      push('gs_booking_page_view',{view:v});
      if(v==='booked')push('gs_booking_complete');
    }
    /* carry source into calendar links */
    document.querySelectorAll('a[href*="meetings"][href*="hubspot.com"]').forEach(function(a){
      try{var u=new URL(a.href);u.searchParams.set('source_page',S.landing_page||location.pathname);
        Object.keys(S).forEach(function(k){if(/^utm_/.test(k))u.searchParams.set(k,S[k])});a.href=u.toString()}catch(e){}
    });
    document.addEventListener('click',function(e){
      var a=e.target.closest&&e.target.closest('a,button');if(!a)return;
      var label=(a.textContent||'').replace(/\s+/g,' ').trim().slice(0,80);
      var r=a.closest('[data-route]');
      if(r||a.classList.contains('choice__card')||a.closest('[id*="__routes"]')){
        push('gs_audience_route_selected',{route:(r&&r.getAttribute('data-route'))||a.getAttribute('href'),label:label});
      }
      if(a.classList.contains('btn--primary')||a.closest('.mobile-bar')){
        push('gs_primary_cta_click',{label:label,destination:a.getAttribute('href')||''});
        if(/meetings.*hubspot\.com/.test(a.getAttribute('href')||''))push('gs_booking_start',{method:'calendar'});
      }
    },true);
    var f=document.querySelector('form[data-enquiry]');
    if(f){var started=false;f.addEventListener('focusin',function(){if(!started){started=true;push('gs_booking_start',{method:'enquiry'})}});}
  }

  function boot(){
    splitWords();
    initNav(); initReveal(); initCounters(); initChapters(); initGallery(); initVideo(); initForm(); initTrack(); initEnquiry(); initWatch(); initToggles(); initDoc();
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ document.documentElement.classList.add('is-loaded'); }); });
  }
  window.GS = { boot: boot, reinit: function(){ document.documentElement.classList.remove('is-loaded'); splitWords(); initReveal(); initCounters(); initChapters(); initGallery(); initVideo(); initForm(); window.scrollTo(0,0); requestAnimationFrame(function(){ requestAnimationFrame(function(){ document.documentElement.classList.add('is-loaded'); }); }); } };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
